import { useContext } from "react";
import { WriterContext } from "../context/writerContext";

// Hook centralizado para acceder al contexto del escritor
export const useWriter = () => {
  const context = useContext(WriterContext);
  if (!context) {
    throw new Error("useWriter debe usarse dentro de un WriterProvider");
  }

  return {
    selectedGenre: context.selectedGenre,
    setSelectedGenre: context.setSelectedGenre,
    isGenreSelectorOpen: context.isGenreSelectorOpen,
    setIsGenreSelectorOpen: context.setIsGenreSelectorOpen,
    isLensPanelOpen: context.isLensPanelOpen,
    setIsLensPanelOpen: context.setIsLensPanelOpen,
    isAIAssistantOpen: context.isAIAssistantOpen,
    setIsAIAssistantOpen: context.setIsAIAssistantOpen,
    isAIConfigOpen: context.isAIConfigOpen,
    setIsAIConfigOpen: context.setIsAIConfigOpen,
    activeProjectId: context.activeProjectId,
    setActiveProjectId: context.setActiveProjectId,
    pendingProjectResume: context.pendingProjectResume,
    isResumeFetching: context.isResumeFetching,
    requestProjectResume: context.requestProjectResume,
    clearPendingProjectResume: context.clearPendingProjectResume,
    activeProject: context.activeProject,
    sections: context.sections,
    activeSection: context.activeSection,
    setActiveSection: context.setActiveSection,
    activeVersion: context.activeVersion,
    activeVersionId: context.activeVersionId,
    setActiveVersionId: context.setActiveVersionId,
    editorContent: context.editorContent,
    setEditorContent: context.setEditorContent,
    isSectionContentReady: context.isSectionContentReady,
    transformEditorContent: context.transformEditorContent,
    transformSectionContent: context.transformSectionContent,
    flushPendingSave: context.flushPendingSave,
    isProjectSetupOpen: context.isProjectSetupOpen,
    setIsProjectSetupOpen: context.setIsProjectSetupOpen,
    projectSetupSection: context.projectSetupSection,
    setProjectSetupSection: context.setProjectSetupSection,
    createNewProject: context.createNewProject,
    createSubsection: context.createSubsection,
    createSection: context.createSection,
    renameSection: context.renameSection,
    deleteSection: context.deleteSection,
    moveSectionUp: context.moveSectionUp,
    moveSectionDown: context.moveSectionDown,
    indentSection: context.indentSection,
    outdentSection: context.outdentSection,
    moveSection: context.moveSection,
    updateSectionStatus: context.updateSectionStatus,
    updateSectionPlanningState: context.updateSectionPlanningState,
    updateSectionLabels: context.updateSectionLabels,
    updateSectionDueDate: context.updateSectionDueDate,
    toggleSectionHidden: context.toggleSectionHidden,
    bulkUpdateSections: context.bulkUpdateSections,
    editingProject: context.editingProject,
    setEditingProject: context.setEditingProject,
    projectRevision: (context as any).projectRevision,
    bumpProjectRevision: (context as any).bumpProjectRevision,
  };
};
